<template>
  <div class="header-container">
    <h1>{{config.title}}</h1>
    <el-dropdown class="login-user">
      <span>{{loginUser}}</span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>
          <span @click="about">关于</span>
        </el-dropdown-item>
        <el-dropdown-item divided>
          <span @click="logout">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div class="clock">
      <span class="clock-date">{{clock.date}}</span>
      <br>
      <span class="clock-time">{{clock.time}}</span>
    </div>
  </div>
</template>
<script>
/* global $config */
import { getNickName, removeToken } from '../../utils/auth'
import { logout } from '../../api/logout.js'
export default {
  data () {
    return {
      clock: {
        date: '',
        time: ''
      },
      config: $config
    }
  },
  computed: {
    loginUser () {
      return getNickName()
    }
  },
  mounted () {
    this.startClock()
  },
  methods: {
    loadClock () {
      var week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      var cd = new Date()
      this.clock.time = zeroPadding(cd.getHours(), 2) + ':' + zeroPadding(cd.getMinutes(), 2) + ':' + zeroPadding(cd.getSeconds(), 2)
      this.clock.date = zeroPadding(cd.getFullYear(), 4) + '/' + zeroPadding(cd.getMonth() + 1, 2) + '/' + zeroPadding(cd.getDate(), 2) + ' ' + week[cd.getDay()]
    },
    startClock () {
      this.loadClock()
      setInterval(this.loadClock, 1000)
    },
    logout () {
      logout()
        .then(resp => {
          if (resp.errmsg === 'ok') {
            removeToken()
            this.$commons.toLogin()
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    about () {
      var version = '1.0'
      this.$alert(`版本 ${version}`, `关于${this.config.title}`, {
        confirmButtonText: '确定'
      })
    }
  }
}
function zeroPadding (num, digit) {
  var zero = ''
  for (var i = 0; i < digit; i++) {
    zero += '0'
  }
  return (zero + num).slice(-digit)
}
</script>

<style scoped>
.header-container {
  width: 100%;
  height: 65px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.clock {
  position: absolute;
  right: 20px;
  top: 10px;
  min-width: 100px;
  line-height: 26px;
  padding-left: 10px;
  border-left: 1px solid #3f3f3f;
}
.clock-date {
  font-size: 12px;
}
.clock-time {
  font-size: 25px;
  font-weight: 700;
}
.login-user{
  position: absolute;
  right: 150px;
  top: 10px;
  height: 60px;
  line-height: 60px;
  color:#fff;
  font-size: 20px;
  font-weight: bold;
  padding-left: 10px;
  border-left: 1px solid #3f3f3f;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/index/Header.vue